import { render, staticRenderFns } from "./hero.vue?vue&type=template&id=1cf5991a&scoped=true"
import script from "./hero.vue?vue&type=script&lang=ts"
export * from "./hero.vue?vue&type=script&lang=ts"
import style0 from "./hero.vue?vue&type=style&index=0&id=1cf5991a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf5991a",
  null
  
)

export default component.exports